import isNil from "lodash/isNil";
import { ProductSearchQueryDto } from "./dto/product-search-query.dto";
import type { IProductSearchGeoContext } from "./product-search-geo-context.interface";

export const SEARCH_RESULTS_LIMIT = 10;
// excludes markdown/amount fields (e.g. "2.730 €" tokenizes to "730") from matching
const SEARCHABLE_ATTRIBUTES = ["name", "title", "tags", "shortDescription"];
const RETRIEVED_ATTRIBUTES = ["uniqueIdentifier"];
// "all" keeps partial national matches from outranking full geo matches (e.g. "agevolazioni milano")
const MATCHING_STRATEGY = "all";

export function buildProductSearchQueries(
  searchText: string,
  geoContext?: IProductSearchGeoContext
): ProductSearchQueryDto[] {
  const relevantExpressions = ["geoZone = national"];

  if (!isNil(geoContext)) {
    relevantExpressions.push(
      `(geoZone = regional AND geoRegions = "${geoContext.regionName}")`,
      `(geoZone = local AND geoMunicipalities = "${geoContext.municipalityCode}")`
    );
  }

  const demotedExpression = `NOT (${relevantExpressions.join(" OR ")})`;

  const relevantQuery = createBaseQuery(searchText);
  relevantQuery.filter = [relevantExpressions];

  const demotedQuery = createBaseQuery(searchText);
  demotedQuery.filter = [[demotedExpression]];

  return [relevantQuery, demotedQuery];
}

function createBaseQuery(searchText: string): ProductSearchQueryDto {
  const query = new ProductSearchQueryDto();
  query.q = searchText;
  query.limit = SEARCH_RESULTS_LIMIT;
  query.attributesToSearchOn = SEARCHABLE_ATTRIBUTES;
  query.attributesToRetrieve = RETRIEVED_ATTRIBUTES;
  query.matchingStrategy = MATCHING_STRATEGY;

  return query;
}
